<template>
	<div>
		<div>
			<span class="xbed-sub-title">值班单管理</span>
		</div>
		<div class="xbed-breadcrumb">
			<Breadcrumb>
				<BreadcrumbItem>麗家会</BreadcrumbItem>
				<BreadcrumbItem>值班单管理</BreadcrumbItem>
			</Breadcrumb>
		</div>
		<br>
		<Form @submit.native.prevent="preventSubmit" inline>
			<FormItem prop='creatTime' label='创建时间：' :label-width='84'>
				<DatePicker type='daterange' v-model="creatTime" placeholder="选择日期" :clearable="false" style="width: 230px" confirm @on-ok='sureCreatDate'></DatePicker>
			</FormItem>
			<FormItem prop='dutyTime' label='值班时间：' :label-width='84'>
				<DatePicker type='daterange' v-model="dutyTime" placeholder="选择日期" :clearable="false" style="width: 230px" confirm @on-ok='sureDutyDate'></DatePicker>
			</FormItem>
			<FormItem label='订单进度' :label-width='84' prop="orderStatus">
				<Select v-model="dutyData.orderStatus" filterable style="width:150px">
					<Option :value="-1">全部</Option>
					<Option :value="0">待接单</Option>
					<Option :value="1">待服务</Option>
					<Option :value="2">待完成</Option>
					<Option :value="3">已完成</Option>
					<Option :value="4">已取消</Option>
				</Select>
			</FormItem>
			<FormItem label='订单状态' :label-width='84' prop="orderType">
				<Select v-model="dutyData.orderType" filterable style="width:150px">
					<Option :value="0">全部</Option>
					<Option :value="1">正常单</Option>
					<Option :value="2">指派单</Option>
					<Option :value="3">人工结单</Option>
					<Option :value="4">取消单</Option>
					<Option :value="5">超时自动结束</Option>
				</Select>
			</FormItem>
			<FormItem label="值班单号：" prop="dutyOrderNo" :label-width="84">
				<Input type="text" v-model="dutyData.dutyOrderNo" style="width:250px"></Input>
			</FormItem>
			<br>
			<FormItem label="值班地点：" prop="buildingAddress" :label-width="84">
				<Input type="text" v-model="dutyData.buildingAddress" style="width:260px"></Input>
			</FormItem>
			<FormItem label="值班管家：" prop="cleaner" :label-width="84">
				<Input type="text" v-model="dutyData.cleaner"></Input>
			</FormItem>
			<FormItem label="下单人：" prop="createName" :label-width="84">
				<Input type="text" v-model="dutyData.createName"></Input>
			</FormItem>
			<FormItem label="联系方式：" prop="contactPhone" :label-width="84">
				<Input type="text" v-model="dutyData.contactPhone"></Input>
			</FormItem>
			<FormItem>
				<Button type="primary" @click="queryAccountKeywords">查询</Button>
			</FormItem>
			<FormItem>
				<Button type="primary" @click="publishDutySheet">发布值班单</Button>
			</FormItem>
			<FormItem>
				<Button type="primary" @click="exportTable" :loading="exportBtn">导出excel表</Button>
			</FormItem>
		</Form>
		<Content>
			<Table stripe :columns="columnsList" :data='dataList' :loading='dutyListLoading'></Table>
			<div style="margin: 10px;overflow: hidden">
				<Page show-sizer :page-size="dutyData.size" :current="dutyData.page" :total="listTotal" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
			</div>
		</Content>
		<!-- 查看工作内容 -->
		<Modal v-model="dutySheetInfoModal.display" ref="dutySheetInfoModal" title="工作内容" :width="500">
			<Input v-model="dutySheetInfoModal.dutyInfos" disabled type="textarea" :autosize="{minRows: 5,maxRows: 10}"></Input>
			<div slot="footer">
				<Button @click="closeDutySheetInfoModal">关闭</Button>
			</div>
		</Modal>
		<!-- 接单日志 -->
		<Modal v-model="singleLogModal.display" ref="singleLogModal" title="查看日志" :width="700">
			<Row v-for="(log, index) in singleLogModal.dutyInfos" :key="`${log.date}-${index}`" type="flex" justify="center" align="middle" class="log-row">
				<Col span="10">{{log.date}}</Col>
				<Col span="14">{{log.detail}}</Col>
			</Row>
			<div slot="footer">
				<Button @click="closeSingleLogModal">关闭</Button>
			</div>
		</Modal>
		<!-- 指派值班单 -->
		<Modal v-model="appointDutySheetModal.display" ref="appointDutySheetModal" title="选择接单人员" :loading="true" :width="800" ok-text="指派值班单" @on-ok="changelDutySheet">
			<Form inline>
				<FormItem prop="keyword" label="账户名：" :label-width="84">
					<Input type="text" v-model="appointDutySheetModal.userName"></Input>
				</FormItem>
				<FormItem prop="keyword" label="手机号：" :label-width="84">
					<Input type="text" v-model="appointDutySheetModal.account"></Input>
				</FormItem>
				<FormItem>
					<Button type="primary" @click="queryWithKeyword">查询</Button>
				</FormItem>
			</Form>
			<Table stripe highlight-row ref="accountTable" :columns="chooseColumns" :data="appointDutySheetModal.data" :loading="false" @on-current-change="changeSelectedAccount"></Table>
			<div style="margin: 10px;overflow: hidden">
				<Page show-sizer placement="top" :total="Ordertotal" :current="appointDutySheetModal.page" :page-size="appointDutySheetModal.size" @on-page-size-change="cleanerChangePageSize" @on-change="cleanerChangePage"></Page>
			</div>
		</Modal>
		<!-- 发布值班单 -->
		<Modal v-model="publishDutySheetModal.display" ref="publishDutySheetModal" title="发布值班单" :loading="true" :width="700" @on-ok="publishDutySheetSure">
			<Form @submit.native.prevent="preventSubmit" :rules="publishDutyRules" ref="publishDutySheetModalForm">
				<FormItem prop='publishDutyTime' label='值班日期' :label-width='100'>
					<DatePicker type="date" multiple placeholder="选择值班日期" style="width: 350px" v-model="publishDutySheetModal.publishDutyTime" :options="disabledPublish"></DatePicker>
				</FormItem>
				<FormItem prop='serviceStartTime' label='值班时间' :label-width='100' style="margin:0;">
					<Row>
						<Col span="8">
							<TimePicker format="HH:mm" confirm placement="bottom-end" placeholder="开始时间" style="width: 150px" v-model="publishDutySheetModal.serviceStartTime"></TimePicker>
						</Col>
						<Col span="8">
							<TimePicker format="HH:mm" confirm placement="bottom-end" placeholder="结束时间" style="width: 150px" v-model="publishDutySheetModal.serviceEndTime"></TimePicker>
						</Col>
					</Row>
				</FormItem>
				<p class="dateTips">*当结束时间大于开始时间系统默认为同一天，小于等于开始时间系统默认为次日*</p>
				<FormItem label='值班地点' :label-width='100' prop="publishPlace">
					<Select v-model="publishDutySheetModal.publishPlace" filterable style="width:500px">
						<Option v-for="palce in buildingPlace" :key="palce.name" :value="palce.buildingId">{{`${palce.buildingId}_${palce.name}`}}</Option>
					</Select>
				</FormItem>
				<!-- <FormItem label='值班管家' :label-width='100' prop="pulishHoseKeeper">
        <Select v-model="publishDutySheetModal.pulishHoseKeeper" filterable style="width:500px">
          <Option v-for="cleaner in cleanerAll" :key='cleaner.userName' :value="cleaner.id">{{`${cleaner.userName}_${cleaner.account}`}}</Option>
        </Select>
      </FormItem> -->
				<FormItem label="联系号码" prop="publishPhone" :label-width="100">
					<Input type="text" v-model="publishDutySheetModal.publishPhone" style="width:500px"></Input>
				</FormItem>
				<FormItem label="值班费用" prop="publishPrice" :label-width="100">
					<Input type="text" v-model="publishDutySheetModal.publishPrice" style="width:500px"></Input>
				</FormItem>
				<FormItem label="工作内容" prop="publishText" :label-width="100">
					<Input type="textarea" :autosize="{minRows: 5,maxRows: 20}" v-model="publishDutySheetModal.publishText" style="width:500px" :maxlength='500'></Input>
				</FormItem>
			</Form>
		</Modal>
	</div>
</template>

<script>
import Moment from "moment"
import Utils from "@/utils";
import API from "@/api";
import Config from "@/config";
import {phoneRegular} from "@/utils/regular.js";

export default {
	async created() {
		this.token = Utils.findFromLocalStorage( "vue-token" );
		this.username = Utils.findFromLocalStorage( "vue-username" );
		this.env = Utils.findFromLocalStorage( "env", "dev" );
	},
	data() {
		const validateGoodsList = {
			publishDutyTime: ( rule, value, callback ) => {
				if (this.publishDutySheetModal.publishDutyTime.length === 0) {
					callback( new Error( '值班日期不能为空' ) )
				} else {
					callback();
				}
			},
			publishPlace: ( rule, value, callback ) => {
				if ( !this.publishDutySheetModal.publishPlace ) {
					callback( new Error( '值班地点不能为空' ) )
				} else {
					callback();
				}
			},
			publishPhone: ( rule, value, callback ) => {
				if ( !phoneRegular.test( this.publishDutySheetModal.publishPhone || this.publishDutySheetModal.publishPhone.length === 0 ) ) {
					callback( new Error( '请填写正确的联系电话' ) )
				} else {
					callback();
				}
			},
			publishPrice: ( rule, value, callback ) => {
				const numReg = /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/;
				if ( !numReg.test( this.publishDutySheetModal.publishPrice ) ) {
					callback( new Error( '请正确填写值班费用' ) )
				} else {
					callback();
				}
			},
			publishText: ( rule, value, callback ) => {
				if ( !this.publishDutySheetModal.publishText ) {
					callback( new Error( '工作内容不能为空' ) )
				} else {
					callback();
				}
			},
		}
		return {
			exportBtn: false,
			// 发布日期不可选择
			disabledPublish: {
				disabledDate( date ) {
					return date && date.valueOf() < Date.now() - 86400000;
				}
			},
			cleanerAll: [],
			buildingPlace: [],
			dataList: [],
			dataLiatLoading: false,
			listTotal: 0,
			//工作内容
			dutySheetInfoModal: {
				display: false,
				dutyInfos: ''
			},
			//接单日志
			singleLogModal: {
				display: false,
				dutyInfos: ''
			},
			// 指派值班单
			Ordertotal: 0,
			selectedAccount: '',
			appointDutySheetModal: {
				data: [],
				dutyId: '',
				display: false,
				userName: '',
				account: '',
				page: 1,
				size: 10
			},
			chooseColumns: [
				{
					title: '手机号',
					key: 'account',
					align: 'center',
					width: 255
				},
				{
					title: '账户名',
					key: 'userName',
					align: 'center',
					width: 255
				},
				{
					title: '管家角色',
					key: 'role',
					align: 'center',
					width: 255
				},
			],
			dutyListLoading: false,
			creatTime: [
				Moment().subtract( 6, 'day' ).format( 'YYYY-MM-DD' ),
				Moment().format( 'YYYY-MM-DD' )
			],//创建时间
			dutyTime: [],//值班时间
			dutyData: {
				createDateStart: '',
				createDateEnd: '',
				dutyDateStart: '',
				dutyDateEnd: '',
				orderStatus: -1,
				dutyOrderNo: '',
				buildingAddress: '',
				cleaner: '',
				createName: '',
				contactPhone: '',
				orderType: 0,
				page: 1,
				size: 10
			},
			columnsList: [
				{
					title: '值班单号',
					key: 'dutyOrderNo',
					align: 'center',
					width: 260
				},
				{
					title: '创建时间',
					key: 'createDate',
					align: 'center',
					width: 130,
					render: ( h, params ) => {
						let time = params.row.createDate ? Moment( params.row.createDate ).format( "YYYY-MM-DD HH:mm:ss" ) : '';
						return h( 'span', {}, time )
					}
				},
				{
					title: '下单人',
					key: 'createName',
					align: 'center',
					width: 130
				},
				{
					title: '值班时间',
					key: 'dutyDate',
					align: 'center',
					width: 370,
					render: ( h, params ) => {
						const start = params.row.serviceDateStart ? Moment( params.row.serviceDateStart ).format( "YYYY-MM-DD HH:mm:ss" ) : '';
						const end = params.row.serviceDateEnd ? Moment( params.row.serviceDateEnd ).format( "YYYY-MM-DD HH:mm:ss" ) : '';
						return ( h, [
							h( 'span', {}, start ),
							h( 'span', {}, '~' ),
							h( 'span', {}, end ),
						] )
					}
				},
				{
					title: '值班地点',
					key: 'buildingAddress',
					align: 'center',
					width: 300
				},
				{
					title: '值班管家',
					key: 'cleanerName',
					align: 'center',
					width: 200,
					render: ( h, params ) => {
						const span = `${ params.row.cleanerName ? params.row.cleanerName : '' }_${ params.row.cleanerMobile ? params.row.cleanerMobile : '' }`;
						return h( 'div', {}, span )
					}
				},
				{
					title: '联系方式',
					key: 'contactPhone',
					align: 'center',
					width: 150
				},
				{
					title: '值班费用（元）',
					key: 'price',
					align: 'center',
					width: 150,
					render: ( h, params ) => {
						const price = params.row.price ? ( params.row.price / 100 ).toFixed( 2 ) : '0';
						return h( 'div', {}, price )
					}
				},
				{
					title: '工作内容',
					key: '',
					align: 'center',
					width: 100,
					render: ( h, params ) => {
						return h( 'Button', {
							props: {
								type: 'primary',
								size: 'small'
							},
							on: {
								click: () => {
									this.watchDutySheetInfo( params.row.id )
								}
							}
						}, '查看' )
					}
				},
				{
					title: '订单进度',
					key: 'orderStatus',
					align: 'center',
					width: 100,
					render: ( h, params ) => {
						let orderStatus = ['待接单', '待服务', '待完成', '已完成', '已取消'][params.row.orderStatus];
						return h( 'div', {}, orderStatus )
					}
				},
				{
					title: '接单日志',
					key: '',
					align: 'center',
					width: 100,
					render: ( h, params ) => {
						return h( 'Button', {
							props: {
								type: 'primary',
								size: 'small'
							},
							on: {
								click: () => {
									this.watchSingleLogModal( params.row.id )
								}
							}
						}, '查看' )
					}
				},
				{
					title: '订单状态',
					key: 'orderType',
					align: 'center',
					width: 120,
					render: ( h, params ) => {
						let orderType = ['', '正常单', '指派单', '人工结单', '取消单', '超时自动结束'][params.row.orderType];
						return h( 'div', {}, orderType )
					}
				},
				{
					title: '操作',
					key: '',
					align: 'center',
					width: 200,
					render: ( h, params ) => {
						const designateOrder = params.row.orderStatus === 0 && params.row.isOverTime === false ? 'inline-block' : 'none'; //指派单
						const dutyOver = ( params.row.orderStatus === 1 || params.row.orderStatus === 2 ) && params.row.isOverTime === false ? 'inline-block' : 'none'; //结束值班单
						const CancelDutySheet = params.row.orderStatus === 0 || params.row.orderStatus === 1 || params.row.orderStatus === 2 ? 'inline-block' : 'none'; //取消值班单
						const dutySheetFinsh = params.row.orderStatus === 3 ? 'block' : 'none'; //已完成 
						const dutySheetCancel = params.row.orderStatus === 4 ? 'block' : 'none'; //已完成 
						return h( 'div', [
							h( 'Button',
								{
									props: {
										type: 'info',
										size: 'small'
									},
									style: {
										margin: '3px',
										display: designateOrder
									},
									on: {
										click: () => {
											if ( !Utils.hasPermission( 'oms_xbclean_xbDutyOrder_assignOrder' ) ) {
												this.$Notice.error( {
													title: "无权限操作"
												} );
												return
											}
											this.appointDutySheetModal.userName = '';
											this.appointDutySheetModal.account = '';
											this.appointDutySheetModal.data = [];
											this.selectedAccount = '';
											this.Ordertotal = 0;
											this.appointDutySheetModal.display = true;
											this.appointDutySheetModal.dutyId = params.row.id;
										}
									}
								}, '指派单' ),
							h( 'Button', {
								props: {
									type: 'warning',
									size: 'small'
								},
								style: {
									margin: '3px',
									display: dutyOver
								},
								on: {
									click: () => {
										if ( !Utils.hasPermission( 'oms_xbclean_xbDutyOrder_overDutyOrder' ) ) {
											this.$Notice.error( {
												title: "无权限操作"
											} );
											return
										}
										this.$Modal.confirm( {
											title: "提示",
											content: `确定结束值班单<span style='color:#000;'>${ params.row.serviceDateStart ? Moment( params.row.serviceDateStart ).format( "YYYY-MM-DD HH:mm:ss" ) : '' }~${ params.row.serviceDateEnd ? Moment( params.row.serviceDateEnd ).format( "YYYY-MM-DD HH:mm:ss" ) : '' }\n${ params.row.buildingAddress }</span>吗？`,
											okText: "确定",
											cancelText: "取消",
											onOk: () => {
												this.preOverDutySheet( {
													dutyOrderId: params.row.id,
													updateName: this.username
												} )
											}
										} );
									}
								}
							}, '结束值班单' ),
							h( 'Button', {
								props: {
									type: 'error',
									size: 'small'
								},
								style: {
									margin: '3px',
									display: CancelDutySheet
								},
								on: {
									click: () => {
										if ( !Utils.hasPermission( 'oms_xbclean_xbDutyOrder_cancelOrder' ) ) {
											this.$Notice.error( {
												title: "无权限操作"
											} );
											return
										}
										this.$Modal.confirm( {
											title: "提示",
											content: `确定取消值班单<span style='color:#000;'>${ params.row.serviceDateStart ? Moment( params.row.serviceDateStart ).format( "YYYY-MM-DD HH:mm:ss" ) : '' }~${ params.row.serviceDateEnd ? Moment( params.row.serviceDateEnd ).format( "YYYY-MM-DD HH:mm:ss" ) : '' }\n${ params.row.buildingAddress }</span>吗？`,
											okText: "确定",
											cancelText: "取消",
											onOk: () => {
												this.cancelOverDutySheet( {
													dutyOrderId: params.row.id,
													updateName: this.username
												} )
											}
										} );
									}
								}
							}, '取消值班单' ),
							h( 'div', {
								style: {
									margin: '3px',
									display: dutySheetFinsh
								}
							}, '已完成' ),
							h( 'div', {
								style: {
									margin: '3px',
									display: dutySheetCancel
								}
							}, '已取消' ),
						] )
					}
				},
			],
			// 发布值班单
			publishDutySheetModal: {
				display: false,
				publishDutyTime: '',
				publishPlace: '',
				pulishHoseKeeper: '',
				publishPhone: '',
				publishPrice: '',
				publishText: '',
				serviceStartDate: '',
				serviceEndDate: '',
				serviceStartTime: '',
				serviceEndTime: ''
			},
			publishDutyRules: {
				publishDutyTime: [
					{required: true, validator: validateGoodsList.publishDutyTime, trigger: 'change'}
				],
				publishPlace: [
					{required: true, validator: validateGoodsList.publishPlace, trigger: 'blur'}
				],
				publishPhone: [
					{required: true, validator: validateGoodsList.publishPhone, trigger: 'blur'}
				],
				publishPrice: [
					{required: true, validator: validateGoodsList.publishPrice, trigger: 'blur'}
				],
				publishText: [
					{required: true, validator: validateGoodsList.publishText, trigger: 'blur'}
				],
			}
		}
	},
	mounted() {
		this.$Notice.config( {
			top: 200
		} );
		this.queryDutyList()
	},
	methods: {
		// 获取列表所有信息
		async queryDutyList() {
			this.dutyListLoading = true;
			let params = {
				createDateStart: this.creatTime[0] ? Moment( this.creatTime[0] ).format( "YYYY-MM-DD" ) : "",
				createDateEnd: this.creatTime[1] ? Moment( this.creatTime[1] ).format( "YYYY-MM-DD" ) : "",
				dutyDateStart: this.dutyTime[0] ? Moment( this.dutyTime[0] ).format( "YYYY-MM-DD" ) : "",
				dutyDateEnd: this.dutyTime[1] ? Moment( this.dutyTime[1] ).format( "YYYY-MM-DD" ) : "",
				orderStatus: this.dutyData.orderStatus == -1 ? '' : this.dutyData.orderStatus,
				orderType: this.dutyData.orderType == 0 ? '' : this.dutyData.orderType,
				dutyOrderNo: this.dutyData.dutyOrderNo,
				buildingAddress: this.dutyData.buildingAddress,
				createName: this.dutyData.createName,
				cleaner: this.dutyData.cleaner,
				contactPhone: this.dutyData.contactPhone,
				page: this.dutyData.page,
				size: this.dutyData.size
			}
			const resp = ( await API.omsAPI[this.env].cleaner.queryXbDutyOrderList( params, this.token ) ).data;
			if ( resp.retCode ) {
				this.$Notice.error( {
					title: "获取值班单列表失败",
					desc: resp.msg
				} );
				return
			}
			this.dataList = resp.content;
			this.listTotal = resp.totalCount;
			this.dutyListLoading = false;
		},
		// 列表查询
		queryAccountKeywords() {
			if ( this.creatTime[0] == '' && this.creatTime[1] == '' ) {
				this.$Notice.error( {
					title: "创建时间不能为空",
				} );
				return;
			}
			this.dutyData.page = 1;
			this.queryDutyList();
		},
		changePageSize( pageSize ) {
			this.dutyData.page = 1;
			this.dutyData.size = pageSize;
			this.queryDutyList()
		},
		changePage( page ) {
			this.dutyData.page = page;
			this.queryDutyList();
		},
		// 创建时间查询（可选时间不能超过90天）
		sureCreatDate() {
			let start = this.creatTime[0];
			let end = this.creatTime[1];
			if ( end.getTime() - start.getTime() > 86400000 * 90 ) {
				this.$Notice.error( {
					title: "所选的查询时不能超过90天",
				} );
				this.creatTime = [];
				return;
			}
		},
		// 值班时间查询（可选时间不能超过90天）
		sureDutyDate() {
			let start = this.dutyTime[0];
			let end = this.dutyTime[1];
			if ( end.getTime() - start.getTime() > 86400000 * 90 ) {
				this.$Notice.error( {
					title: "所选的查询时不能超过90天",
				} );
				this.dutyTime = [];
				return;
			}
		},
		// 查看工作内容
		async watchDutySheetInfo( id ) {
			this.dutySheetInfoModal.display = true;
			const resp = ( await API.omsAPI[this.env].cleaner.queryXbDutyOrderGetContent( {dutyOrderId: id}, this.token ) ).data;
			this.dutySheetInfoModal.dutyInfos = resp;
		},
		closeDutySheetInfoModal() {
			this.dutySheetInfoModal.display = false;
		},
		// 查看日志
		async watchSingleLogModal( id ) {
			this.singleLogModal.display = true;
			const resp = ( await API.omsAPI[this.env].cleaner.queryXbDutyOrderFindLog( {dutyOrderId: id}, this.token ) ).data;
			this.singleLogModal.dutyInfos = resp;
		},
		closeSingleLogModal() {
			this.singleLogModal.display = false;
		},
		// 结束值班单
		async preOverDutySheet( query ) {
			const resp = ( await API.omsAPI[this.env].cleaner.xbDutyOrderOverDutyOrder( query, this.token ) ).data;
			if ( resp.retCode ) {
				this.$Notice.error( {
					title: "结束值班单失败",
					desc: resp.msg
				} );
				return
			}
			this.$Notice.success( {
				title: "结束值班单成功",
				desc: resp.msg
			} );
			this.queryDutyList();
		},
		// 取消值班单
		async cancelOverDutySheet( query ) {
			const resp = ( await API.omsAPI[this.env].cleaner.xbDutyOrderCancelOrder( query, this.token ) ).data;
			if ( resp.retCode ) {
				this.$Notice.error( {
					title: "取消值班单失败",
					desc: resp.msg
				} );
				return
			}
			this.$Notice.success( {
				title: "取消值班单成功",
				desc: resp.msg
			} );
			this.queryDutyList();
		},
		// 获取值班楼宇信息
		async builingInfo() {
			const resp = ( await API.omsAPI[this.env].cleaner.queryXbDutyOrderGetBuildingList( {search: ''}, this.token ) ).data;
			if ( resp.retCode ) {
				this.$Notice.error( {
					title: "获取楼宇信息失败",
					desc: resp.msg
				} );
				return
			}
			this.buildingPlace = resp;
		},
		// 获取所有管家信息
		async allCleaner() {
			const resp = ( await API.omsAPI[this.env].cleaner.cleanerAccountAcceptData( {}, this.token ) ).data;
			this.cleanerAll = resp.content;
		},
		// 发布值班单弹窗
		publishDutySheet() {
			if ( !Utils.hasPermission( 'oms_xbclean_xbDutyOrder_add' ) ) {
				this.$Notice.error( {
					title: "无权限操作"
				} );
				return
			}
			this.builingInfo()
			// this.allCleaner()
			this.publishDutySheetModal.publishDutyTime = '';
			this.publishDutySheetModal.publishPlace = '';
			this.publishDutySheetModal.pulishHoseKeeper = '';
			this.publishDutySheetModal.publishPhone = '';
			this.publishDutySheetModal.publishPrice = '';
			this.publishDutySheetModal.publishText = '';
			this.publishDutySheetModal.serviceStartTime = '';
			this.publishDutySheetModal.serviceEndTime = '';
			this.publishDutySheetModal.display = true;
		},
		// 选择接单人员
		async changelDutySheet() {
			if ( !this.selectedAccount ) {
				this.$Notice.error( {
					title: "请指定接单人员"
				} );
				this.$refs.appointDutySheetModal.buttonLoading = false;
				return
			}
			let params = {
				cleanerId: this.selectedAccount.id,
				dutyOrderId: this.appointDutySheetModal.dutyId,
				updateName: this.username
			}
			const resp = ( await API.omsAPI[this.env].cleaner.xbDutyOrderAssignOrder( params, this.token ) ).data;
			if ( resp.retCode ) {
				this.$Notice.error( {
					title: "指派失败",
					desc: resp.msg
				} );
				this.$refs.appointDutySheetModal.buttonLoading = false;
				return
			}
			this.$Notice.success( {
				title: "指派成功",
				desc: resp.msg
			} );
			this.$refs.appointDutySheetModal.buttonLoading = false;
			this.queryDutyList()
			this.appointDutySheetModal.display = false;
		},
		// 指派单查询
		async queryWithKeyword() {
			const params = {
				page: this.appointDutySheetModal.page,
				size: this.appointDutySheetModal.size,
				userName: this.appointDutySheetModal.userName,
				account: this.appointDutySheetModal.account
			}
			const resp = ( await API.omsAPI[this.env].cleaner.cleanerAccountAcceptData( params, this.token ) ).data;
			if ( resp.retCode ) {
				this.$Notice.error( {
					title: "指派单查询失败",
					desc: resp.msg
				} );
				return
			}
			this.appointDutySheetModal.data = resp.content;
			this.Ordertotal = resp.totalCount;
		},
		// 指派单分页
		cleanerChangePageSize( pageSize ) {
			this.appointDutySheetModal.page = 1;
			this.appointDutySheetModal.size = pageSize;
			this.queryWithKeyword();
		},
		cleanerChangePage( page ) {
			this.appointDutySheetModal.page = page;
			this.queryWithKeyword();
		},
		changeSelectedAccount( currAccount ) {
			if ( currAccount ) {
				this.selectedAccount = currAccount;
			} else {
				this.$refs.accountTable.clearCurrentRow();
			}
		},
		// 发布值班单
		async publishDutySheetSure() {
			// if ( !this.publishDutySheetModal.publishDutyTime ) {
			// 	this.$Notice.error( {
			// 		title: "请先选择值班时间",
			// 	});
			// 	this.$refs.publishDutySheetModal.buttonLoading = false;		
			// 	return;
			// }
			if (!this.publishDutySheetModal.serviceEndTime || !this.publishDutySheetModal.serviceStartTime ) {
				this.$Notice.error( {
					title: "请先选择值班时间",
				});
				this.$refs.publishDutySheetModal.buttonLoading = false;
				return;
			}
			let validResult = false;
			this.$refs.publishDutySheetModalForm.validate( valid => {
				validResult = valid
			} );
			if ( !validResult ) {
				this.$refs.publishDutySheetModal.buttonLoading = false;
				return;
			}

			let arrTime = this.publishDutySheetModal.publishDutyTime;
			let arrAfter = []
			arrTime.forEach( ele => {
				let time = Moment( ele ).format( 'YYYY-MM-DD' )
				arrAfter.push( time )
			} );
			let str = ''
			arrAfter.forEach( day => {
				str += day + ','
			} )
			let strDay = str.substring( 0, str.lastIndexOf( ',' ) )

			let params = {
				buildingId: this.publishDutySheetModal.publishPlace,
				cleanerId: this.publishDutySheetModal.pulishHoseKeeper,
				contactPhone: this.publishDutySheetModal.publishPhone,
				content: this.publishDutySheetModal.publishText,
				createName: this.username,
				price: ( this.publishDutySheetModal.publishPrice * 100 ).toFixed( 0 ),
				serviceDate: strDay,
				serviceEndTime: this.publishDutySheetModal.serviceEndTime,
				serviceStartTime: this.publishDutySheetModal.serviceStartTime
			}
			const resp = ( await API.omsAPI[this.env].cleaner.postXbDutyOrderAdd( params, this.token ) ).data;
			if ( resp.retCode ) {
				this.$Notice.error( {
					title: "发布失败",
					desc: resp.msg
				} );
				this.$refs.publishDutySheetModal.buttonLoading = false;
				return
			}
			this.$Notice.success( {
				title: "发布成功",
				desc: resp.msg
			} );
			this.$refs.publishDutySheetModal.buttonLoading = false;
			this.queryDutyList()
			this.publishDutySheetModal.display = false;
		},
		// 导出列表
		exportTable() {
			if ( !Utils.hasPermission( 'excel_exportDutyOrderList' ) ) {
				this.$Notice.error( {
					title: "无权限操作"
				} );
				return
			}
			let params = {
				createDateStart: this.dutyData.createDateStart ? this.dutyData.createDateStart : "",
				createDateEnd: this.dutyData.createDateEnd ? this.dutyData.createDateEnd : "",
				dutyDateStart: this.dutyData.dutyDateStart ? this.dutyData.dutyDateStart : "",
				dutyDateEnd: this.dutyData.dutyDateEnd ? this.dutyData.dutyDateEnd : "",
				orderStatus: this.dutyData.orderStatus == -1 ? '' : this.dutyData.orderStatus,
				orderType: this.dutyData.orderType == 0 ? '' : this.dutyData.orderType,
				dutyOrderNo: this.dutyData.dutyOrderNo,
				buildingAddress: this.dutyData.buildingAddress,
				createName: this.dutyData.createName,
				cleaner: this.dutyData.cleaner,
				contactPhone: this.dutyData.contactPhone,
				page: 1,
				size: 999999
			}
			const initParam = params => {
				let paramStr = '';
				Object.keys( params ).forEach( item => {
					if ( params[item] !== '' ) {
						paramStr += item + '=' + params[item] + '&';

					}
				} )
				return paramStr.substring( 0, paramStr.lastIndexOf( '&' ) );
			}
			let paramsInfos = initParam( params );
			let url = `${ Config[this.env].analysisUrl }excel/exportDutyOrderList?${ paramsInfos }`;
			// window.open(url,'_blank')
			Utils.exportExcelWeighting( url, this.token, this.$Notice.error, this, "exportBtn" )
		},
		preventSubmit() {
			return false;
		},
	}
}
</script>

<style scoped>
.dateTips {
	height: 25px;
	line-height: 25px;
	color: red;
	margin-bottom: 5px;
	margin-left: 28px;
}
</style>



// WEBPACK FOOTER //
// src/pages/cleaner/dutyOrder-list.vue